module.exports = __webpack_public_path__ + "768a18fd12de478c218d3e973fc51286.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-66.svg
// module id = 591
// module chunks = 0